import { AppContext } from '../state';
import {useContext} from 'react';

/**
 * @typedef UserHookValues
 * @property {Object} assignment - returns an assignment, if present. Only available on branch guides
 * @property {function} hasAssignment - returns true if employee and / or branch assignment exists on this user
 * @property {function} getBranch - returns active branch if present, else returns false
 * @property {function} getEmployee - returns employee object if present, else returns false
 * @property {string} uuid - the users conversation ID
 */
/**
 *
 * @returns {UserHookValues}
 */
const useUser = () => {
  const { user: { assignment, uuid } } = useContext(AppContext);
  const getBranch = () => assignment?.branch ? assignment.branch : {};
  const getEmployee = () => assignment?.employee ? assignment.employee : {};
  const hasAssignment = () => !!assignment?.employee?.firstName;
  return {
    assignment,
    hasAssignment,
    getBranch,
    getEmployee,
    uuid
  };
};

export { useUser };
